import { LinkProps } from '@tanstack/react-router';
import { PersonTargetType, TargetType } from '@/types/TargetType.ts';

/**
 * Odnośnik jako dane dla `<Link>` — wyłącznie dla miejsc, które celu nie znają
 * w czasie kompilacji. Kto go zna, podaje literał ścieżki wprost w `<Link>`.
 */
export type DetailsLink = Pick<LinkProps, 'to' | 'params' | 'search'>;

/**
 * Ekran osoby — cel rozstrzyga rodzaj osoby, więc literały ścieżek stoją tu,
 * a nie w komponencie. Trybu nie ustawiamy: `<Link>` przenosi bieżący `search`.
 */
export const personScreenLink = (
  kind: PersonTargetType,
  personId: string,
): DetailsLink =>
  kind === TargetType.CLIENT
    ? {
        to: '/app/clients/$clientId/info',
        params: { clientId: personId },
      }
    : {
        to: '/app/participants/$participantId/info',
        params: { participantId: personId },
      };
